import React from 'react';
import AgentDashboard from './AgentDashboard';

const IRISDashboard: React.FC = () => {
  const agentConfig = {
    id: 'iris',
    displayName: 'IRIS',
    icon: '/assets/logos/aldo-iris.png',
    color: '#6f747b',
    description: 'IRIS system support assistant',
    hasTestResults: false
  };

  return <AgentDashboard agentConfig={agentConfig} />;
};

export default IRISDashboard;

